module.exports = __webpack_public_path__ + "img/20918800000101.3a59e88b.png";